import React from "react";
import log from "cslog";
import {
	parseStyle,
	decodeStyle,
	mobile,
	tablet,
	isHidden,
} from "../../../juntion";
import { useAction } from "../../../hooks";
import { useAtom } from "jotai";
import { lightboxAtom } from "../../../db";
// import { parseImageSrc } from "../../../../dynamicdata/parser";
import { parseImageSrc } from "../../../junctionAbs";
import { css } from "@emotion/css";
import classNames from "classnames";

function Img({ id, db, dydb, gs, device }) {
	const { performAction } = useAction();
	const [_, setLB] = useAtom(lightboxAtom);
	const data = db[id];

	const ps = parseStyle(data, gs, data.cstate);

	if (isHidden(ps.classes, device)) {
		return null;
	}

	const tabletStyle = tablet(device) ? ps.tablet : {};
	const mobileStyle = mobile(device) ? ps.mobile : {};

	let input = ps.input;
	input = { ...input, ...(tablet(device) && ps.itablet) };
	input = { ...input, ...(mobile(device) && ps.imobile) };

	// let imgSrc = parseImgURL(input.imageSource);

	// if (!("params" in input.imageSource)) {
	//     imgSrc = parseImageSrc(dydb, input.imageSource);
	// }
	const imgSrc = parseImageSrc(dydb, input.imageSource);

	const imgStyle = {
		width: input.imageSize.value,
		...decodeStyle(ps.fixStyle, gs),
		...decodeStyle(ps.style, gs),
		...(tablet(device) && decodeStyle(tabletStyle, gs)),
		...(mobile(device) && decodeStyle(mobileStyle, gs)),
		alignSelf: input.alignImage,
	};

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
			}}
		// className={input.hoverAnimation}
		>
			{input.imageHeight?.value === "auto" ? (
				<img
					className={classNames(
						input.hoverAnimation,
						css({
							"&:hover": decodeStyle(ps.hover, gs),
							...imgStyle,
						})
					)}
					src={imgSrc}
					alt={input.imageDescription}
					onClick={(e) => {
						log.p("Image clecked");
						if (input.lightbox) {
							e.stopPropagation();
							setLB([imgSrc]);
						} else {
							if (input.action?.type !== "none") {
								e.stopPropagation();
								performAction({
									...input.action,
									dydb: dydb,
								});
							}
						}
					}}
				/>
			) : (
				<div
					style={{
						position: "relative",
						"--abababab": input.imageHeight.value,
						overflow: "hidden",
						...imgStyle,
					}}
					className="qimg_container"
					// className={input.hoverAnimation}
					onClick={(e) => {
						log.d("Image clicked");
						if (input.lightbox) {
							e.stopPropagation();
							setLB([imgSrc]);
						} else {
							if (input.action?.type !== "none") {
								e.stopPropagation();
								performAction({
									...input.action,
									dydb: dydb,
								});
							}
						}
					}}
				>
					<img
						src={imgSrc}
						alt="preview"
						style={
							{
								// objectFit: "fill",  //cover, contain, scale-down
							}
						}
					/>
				</div>
			)}
		</div>
	);
}

export default Img;
